<template>
	<div
		style="position: fixed; height: 100%; top: 0; z-index: 999; background-color: rgba(0,0,0,0.7);  align-items: center;">
		<div class="inpage" style="display: flex; height: 100%; width: 100%;">
			<img :src="ourl" ref="image" alt="" style="width: 100%; height: auto;">
		</div>
		<div class="btnok" @click="sureSava">确认裁剪</div>
		
		<div class="btnclose1" @click="clsoeCropper">
			<img :src="'./images/close.png'"  alt="" style="width: 100%;">
		</div>
		
	</div>
</template>
<script>
	import Cropper from 'cropperjs'
	import 'cropperjs/dist/cropper.css'
	export default {
		name: 'sign',
		props:['ourl'],
		data() {
			return {
				myCropper: null,
				afterImg: '',
				afterUrl:"",
				
			}
		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				this.myCropper = new Cropper(this.$refs.image, {
					viewMode: 1,
					dragMode: 'none',
					initialAspectRatio: 1,
					aspectRatio: 1,
					background: false,
					movable:true,
					autoCropArea: 0.6,
					zoomOnWheel: false,
					aspectRatio: 358 / 441,
				})
			},
			sureSava() {
				this.afterImg = this.myCropper.getCroppedCanvas({
					imageSmoothingQuality: 'high'
				}).toDataURL('image/png')

				
				this.$http.post("/api/save_base64_img", {
					base64_img: this.afterImg
				}).then(res => {
					
					this.afterUrl = res.data.url
					this.clsoeCropper()
				})


			},
			clsoeCropper(){
				console.log(this.afterUrl)
				this.$emit("getImage",this.afterUrl)
			}
		}
	}
</script>

<style scoped="">
	.btnok {
		width: 40%;
		left: 30%;
		height: 50px;
		line-height: 50px;
		background-color: #007AFF;
		color: #fff;
		bottom: 100px;
		z-index: 99999;
		position: absolute;
		text-align: center;
		border-radius: 4px;
	}
	.btnok:active{
		background-color: #0000FE;
	}
	
	.btnclose1{
		width: 30px;
		height: 30px;
		position: absolute;
		top: 20px;
		right: 20px;
		
	}
</style>
